import { React, useState, useEffect, useContext } from "react";
import "../../../assets/css/table.css";
import Loading from "react-fullscreen-loading";
import { Link } from "react-router-dom";
import HeaderSection from "../banner/HeaderSection";
import DivLoader from "../../../component/utilities/Spinner";
import DataTable from "react-data-table-component";
import axios from "axios";
import { toast } from "react-toastify";
import * as CONST from "../../../component/config/Constant";
import { AuthContext } from "../../../component/context/AuthContext";
import { Modal, Button } from "react-bootstrap";
import JoditEditor from "jodit-react";
import MultiSelect from "react-multiple-select-dropdown-lite";
import "react-multiple-select-dropdown-lite/dist/index.css";
import Form from "../../../component/utilities/Forms";
import { useRef, useMemo } from "react";
import { ViewIcon, AddIcon } from "../../../component/utilities/ActionIcons";
 
function EmployeeLibraryListing() {
  const [authUserData] = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [maxPageLimit, setMaxPageLimit] = useState(10);
  const [minPageLimit, setMinPageLimit] = useState(0);
 
  //Search
  const [searchTechnologyName, setSearchTechnology] = useState("");
  const [dataSort, setDataSort] = useState({
    order: "desc",
    order_by: "id",
  });
 
  const pageNumberLimit = { perPage };
 
  // Modal State
  const [show, setShow] = useState(false);
  const [action, setAction] = useState("");
  const [questionId, setQuestionId] = useState(0);
  const [questionTitle, setQuestionTitle] = useState("");
  const [techDescription, setDescription] = useState("");
  const [allTechVersions, setAllTechVersions] = useState([]);
  const [versionValue, setVersionValue] = useState("");
  const [selectedTechId, setSelectedTechId] = useState(0);
   const [validate, setValidate] = useState({});
 
   const handleClearValidate = (name) => {
     if (validate.validate && validate.validate[name]) {
       setValidate({
         validate: { ...validate.validate, [name]: undefined },
       });
     }
   };
  const [fullLoading, setFullLoading] = useState(false);
    const [visibilityStatus, setVisibilityStatus] = useState("1");
 
 
  const editor = useRef(null);
  const config = useMemo(() => ({
    readonly: false,
    uploader: { insertImageAsBase64URI: true },
  }), []);
 
  let isToken = "";
  if (authUserData && authUserData[0]) {
    isToken = authUserData[0].token ? authUserData[0].token : "";
  }
 
  const [searchParam, setSearchParam] = useState({
    "srchStatus": "1", // Employees only see active technologies
    "srchTechnology": searchTechnologyName,
  });
 
  useEffect(() => {
    fetchTechnologyData(searchParam, dataSort, activePage, perPage);
  }, [searchParam, dataSort, activePage]);
 
  async function technologySearch() {
    setSearchParam({
      "srchStatus": "1",
      "srchTechnology": searchTechnologyName,
    });
    setDataSort({
      order: "desc",
      order_by: "id",
    });
    setActivePage(1);
  }
 
  function clearSearch() {
    setSearchTechnology("");
    setSearchParam({
      srchStatus: "1",
      srchTechnology: ""
    });
    setDataSort({
      order: "desc",
      order_by: "id",
    });
    setActivePage(1);
  }
 
  async function fetchTechnologyData(paramSearch, paramSort, paramPage, paramLimit) {
    setLoading(true);
    await axios
      .post(
        CONST.GET_TECHNOLOGY_LIST,
        {
          limit: paramLimit,
          search_input: paramSearch,
          page_number: paramPage,
          sort: paramSort,
        },
        {
          headers: {
            Authorization: `Bearer ${isToken}`,
          },
        }
      )
      .then((response) => {
        const status = response.data.status;
        if (status === "success") {
          setData(response.data.data);
          setTotalRows(response.data.count);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching technology data:", error);
      });
    setLoading(false);
  }
 
  async function getVersionsForModal(techId) {
    let apiUrl = CONST.GET_TECHNOLOGY_VERSIONS + `${techId}`;
    await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${isToken}` }
    }).then((response) => {
      if (response.data.status === "success") {
        setAllTechVersions(response.data.data.map(v => ({ label: v.version, value: String(v.id) })));
      }
    });
  }
 
  const handleShow = (mode, techId) => {
    setValidate({});
    setSelectedTechId(techId);
    setQuestionId(0);
    setQuestionTitle("");
    setVersionValue("");
    setDescription("");
    setAction(mode);
    getVersionsForModal(techId);
    setShow(true);
    setVisibilityStatus("1");
  };
 
   const handleClose = () => {
     setShow(false);
     setValidate({});
   };
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    let validator = Form.validator({
      versionValue: { value: versionValue, isRequired: true, label: "Version" },
      questionTitle: { value: questionTitle, isRequired: true, label: "Title" },
      techDescription: { value: techDescription, isRequired: true, label: "Description" },
    });
 
    if (validator) {
      setValidate({ validate: validator.errors });
      return;
    }
 
    setDisabled(true);
    setFullLoading(true);
    await axios.post(CONST.ADD_QUESTION, {
      technology_id: selectedTechId,
      question_id: 0,
      title: questionTitle,
      version_id: [versionValue],
      description: techDescription,
      status: visibilityStatus === "1" ? "1" : "0"
    }, {
      headers: { Authorization: `Bearer ${isToken}` }
    }).then((response) => {
      if (response.data.status === "success") {
        toast.success("Article submitted for approval!");
        handleClose();
      } else {
        toast.error(response.data.message);
      }
    }).finally(() => { setFullLoading(false); setDisabled(false); });
  };
 
  const columns = [
    {
      name: "Sr. No",
      selector: (row, index) => (activePage - 1) * perPage + index + 1,
      width: "10%",
    },
    {
      name: "Technology",
      selector: (row) => row.name,
      sortable: true,
      sortField: "name",
      width: "30%",
      cell: (row) => (
        <Link to={CONST.ADMIN_PRE + "employee-articles/" + row.id}>
          {row.name}
        </Link>
      ),
    },
    {
      name: "Image",
      cell: (row) => (
        <div className="py-2">
          {row.image_path ? (
            <img
              src={CONST.HOST + row.image_path}
              alt={row.name}
              style={{ maxHeight: "40px", maxWidth: "100px" }}
            />
          ) : (
            <span className="text-muted">No Image</span>
          )}
        </div>
      ),
      width: "20%",
    },
    {
      name: "Versions",
      selector: (row) =>
        row.versions
          ? row.versions.map((v) => v.version).join(", ")
          : "",
      width: "25%",
    },
    {
  name: "Action",
  width: "15%",
  cell: (row) => (
    <div className="d-flex align-items-center gap-1">
      <ViewIcon to={CONST.ADMIN_PRE + "employee-articles/" + row.id} tooltip="View Articles" />
      <AddIcon onClick={() => handleShow("Add", row.id)} tooltip="Add Article" />
    </div>
  ),
},
  ];
 
  const handleSort = async (column, sortDirection) => {
    setActivePage(1);
    setDataSort({
      order: sortDirection,
      order_by: column.sortField,
    });
  };
 
  const handlePageChange = async (page) => {
    setActivePage(parseInt(page));
  };
 
  const BootyPagination = ({
    rowsPerPage,
    rowCount,
    onChangePage,
    currentPage,
  }) => {
    const pages = Math.ceil(rowCount / rowsPerPage);
    const pageItems = Array.from({ length: pages }, (_, i) => i + 1);
    const nextDisabled = currentPage === pages;
    const previousDisabled = currentPage === 1;
 
    const handleBackButtonClick = () => onChangePage(currentPage - 1);
    const handleNextButtonClick = () => onChangePage(currentPage + 1);
 
    return (
      <div className="card-footer d-flex justify-content-between align-items-center">
        <p className="m-0 text-muted">
          Showing {(currentPage - 1) * perPage + 1} to {Math.min(currentPage * perPage, rowCount)} of {rowCount} entries
        </p>
        <ul className="pagination m-0 ms-auto">
          <li className={`page-item ${previousDisabled ? "disabled" : ""}`}>
            <button className="page-link" onClick={handleBackButtonClick} disabled={previousDisabled}>«</button>
          </li>
          {pageItems.slice(Math.max(0, currentPage - 3), Math.min(pages, currentPage + 2)).map((page) => (
            <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
              <button className="page-link" onClick={() => onChangePage(page)}>{page}</button>
            </li>
          ))}
          <li className={`page-item ${nextDisabled ? "disabled" : ""}`}>
            <button className="page-link" onClick={handleNextButtonClick} disabled={nextDisabled}>»</button>
          </li>
        </ul>
      </div>
    );
  };
 
  return (
    <>
      <HeaderSection
        title="Employee"
        heading="Article Portal"
      />
      <div className="page-body">
        <div className="container-xl">
          <div className="row row-cards">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Select Technology to Browse or Add Articles</h3>
                </div>
                <div className="card-body border-bottom py-3">
                  <div className="row align-items-end">
 
                    {/* Search Input */}
                    <div className="col-md-6">
                      <label className="form-label">Search Technology</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Technology Name..."
                        value={searchTechnologyName}
                        onChange={(e) => setSearchTechnology(e.target.value)}
                      />
                    </div>
 
                    {/* Buttons with Icons */}
                    <div className="col-md-6">
                      <div className="d-flex gap-2 mt-2 mt-md-0">
 
                        {/* Search Button */}
                        <button
                          type="button"
                          className="btn btn-primary d-flex align-items-center "
                          onClick={technologySearch}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="me-1"
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            strokeWidth="2"
                            stroke="currentColor"
                            fill="none"
                          >
                            <circle cx="10" cy="10" r="7"></circle>
                            <line x1="21" y1="21" x2="15" y2="15"></line>
                          </svg>
                          Search
                        </button>
 
                        {/* Clear Button */}
                        <button
                          type="button"
                          className="btn btn-outline-primary d-flex align-items-center ml-3"
                          onClick={clearSearch}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="me-1"
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            strokeWidth="2"
                            stroke="currentColor"
                            fill="none"
                          >
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                          </svg>
                          Clear
                        </button>
 
                      </div>
                    </div>
 
                  </div>
                </div>
                <div className="table-responsive">
                  <DataTable
                    columns={columns}
                    data={data}
                    progressPending={loading}
                    progressComponent={<div className="p-4"><DivLoader color="primary" /></div>}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    paginationPerPage={perPage}
                    paginationComponent={BootyPagination}
                    sortServer
                    onSort={handleSort}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
       <ArticleModal
         show={show}
         handleClose={handleClose}
         action={action}
         versionValue={versionValue}
         setVersionValue={setVersionValue}
         allTechVersions={allTechVersions}
         validate={validate}
         questionTitle={questionTitle}
         setQuestionTitle={setQuestionTitle}
         techDescription={techDescription}
         setDescription={setDescription}
         editor={editor}
         config={config}
         handleSubmit={handleSubmit}
         visibilityStatus={visibilityStatus}
         setVisibilityStatus={setVisibilityStatus}
         handleClearValidate={handleClearValidate}
         disabled={disabled}
       />
      <Loading loading={fullLoading} background="rgba(0,0,0,0.5)" loaderColor="#fff" />
    </>
  );
}
 
const ArticleModal = ({ show, handleClose, action, versionValue, setVersionValue, allTechVersions, validate, questionTitle, setQuestionTitle, techDescription, setDescription, editor, config, handleSubmit, visibilityStatus, setVisibilityStatus, handleClearValidate, disabled }) => (
  <Modal size="lg" show={show} onHide={handleClose}>
    <Modal.Header closeButton>
      <Modal.Title>{action} Article</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <form onSubmit={handleSubmit}>
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label required">Select Version(s)</label>
            <MultiSelect
              value={versionValue}
              onChange={(val) => {
                setVersionValue(val);
                handleClearValidate("versionValue");
              }}
              options={allTechVersions}
              className={validate.validate?.versionValue ? "is-invalid" : ""}
            />
            {validate.validate?.versionValue && (
              <div className="invalid-feedback d-block">
                {validate.validate.versionValue}
              </div>
            )}
          </div>
          <div className="col-12">
            <label className="form-label required">Article Title</label>
            <input
              className={`form-control ${validate.validate?.questionTitle ? "is-invalid" : ""}`}
              value={questionTitle}
              onChange={(e) => {
                setQuestionTitle(e.target.value);
                handleClearValidate("questionTitle");
              }}
              placeholder="E.g. How to install React"
            />
            {validate.validate?.questionTitle && (
              <div className="invalid-feedback">
                {validate.validate.questionTitle}
              </div>
            )}
          </div>
          <div className="col-12">
            <label className="form-label required">Content / Description</label>
            <JoditEditor
              ref={editor}
              config={config}
              value={techDescription}
              onBlur={(val) => {
                setDescription(val);
                if (val) handleClearValidate("techDescription");
              }}
            />
            {validate.validate?.techDescription && (
              <div className="invalid-feedback d-block">
                {validate.validate.techDescription}
              </div>
            )}
          </div>
          <div className="col-md-4">
            <label className="form-label required">Visibility Status</label>
          <select
            key={visibilityStatus}
            className="form-select"
            value={visibilityStatus}
            onChange={(e) => setVisibilityStatus(e.target.value)}
          >
            <option value="1">Active</option>
            <option value="0">Inactive</option>
          </select>
        </div>
        </div>
      </form>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={handleClose}>Cancel</Button>
      <Button variant="primary" onClick={handleSubmit} disabled={disabled}>{disabled ? "Submitting..." : "Submit Article"}</Button>
    </Modal.Footer>
  </Modal>
);
 
export default EmployeeLibraryListing;